import type { FC } from "react"
import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useInboxAddresses } from "@/lib/use-inbox-addresses"
import { useThreadsFilterState } from "../threads-filter-state"

export const InboxFilterItems: FC<SharedFilterItemsProps> = ({ onSelect }) => {
	const { emailAddressIds, addEmailAddress, removeEmailAddress } =
		useThreadsFilterState()
	const addresses = useInboxAddresses()

	if (addresses.length === 0) {
		return (
			<div className="py-4 text-center text-sm">
				This workspace has a single email address
			</div>
		)
	}

	return (
		<>
			{addresses.map((address) => {
				const isSelected = emailAddressIds.includes(address.id)

				return (
					<CommandItem
						key={address.id}
						value={address.primaryEmail}
						onSelect={() => {
							if (isSelected) {
								removeEmailAddress(address.id)
							} else {
								addEmailAddress(address.id)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<span className="flex-1 truncate">{address.primaryEmail}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
